'use client';

import { X } from 'lucide-react';
import type { TFunction } from 'i18next';

interface SidebarMobileHeaderProps {
  t: TFunction<'translation', undefined>;
  onClose: (() => void) | undefined;
}

export function SidebarMobileHeader({
  t,
  onClose,
}: SidebarMobileHeaderProps) {
  return (
<div className="lg:hidden flex items-center justify-between gap-2 px-4 py-3 border-b shrink-0 bg-background">
          <h2 className="text-sm font-semibold">{t('search.filters')}</h2>
          <button
            type="button"
            onClick={onClose}
            aria-label={t('common.buttons.close', { defaultValue: 'Close' })}
            className="inline-flex items-center justify-center w-11 h-11 rounded-full hover:bg-muted"
          >
            <X size={20} />
          </button>
        </div>
  );
}
